module.exports = __webpack_public_path__ + "img/switchCamera.c01195dc.png";